import { joinParams } from '../utils'

export default {

  /**
   * 获取订单列表 （入住单列表）
   * @param {+} page 分页 
   * @param {+} size 每页数 
   * @param {+} startDate  
   * @param {+} endDate
   * @param {*} sourceType 订单来源
   * @param {*} stat 订单状态 （1 = 有效订单）
   * @param {*} checkin 入住状态
   * @param {*} orderNo 订单号
   * @param {*} roomNo 房间号
   * @param {*} orderName 姓名
   * @param {*} checkInTimeBegin 预入住开始时间
   * @param {*} checkInTimeEnd 预入住结束时间
   * @param {*} quitTimeBegin 预退房开始时间
   * @param {*} quitTimeEnd 预退房结束时间
   * @param {*} phone 
   * @param {*} payStat 
   * @param {*} chainName 
   * @param {*} rentType 
   * @param {*} otherNo 
   */
  getOrderList(params, type) {
    const url = type ? type : "/api/checkinInfo/byDateExt"
    return this.instance.get(url, {
      params: params
    })
  },

  // 一键夜审
  oneKeyNightAuditorXms(params) {
    return this.instance.post('/api/nightAuditor/oneKeyNightAuditorXms', { ...params })
  },
  // 入住单列表（查询门店指定房间和营业日的入住单）
  getCheckinList(params) {
    return this.instance.get('/api/checkin/byDateChecnkinExt', {
      params: params
    })
  },
  /**
   * 添加入住人
   * @param {*} params 
   * @parma {+} name 姓名
   * @parma {+} phone 手机号
   * @parma {+} source 用户来源
   * @parma {+} id_no 身份证号码
   * @parma {+} id_valid_period 身份证有效期YYYY.MM.dd-YYYY.MM.dd
   * @parma {+} id_photo 身份证头像
   * @parma {+} checkin_id 入住单id
   */
  addCheckiner(params) {
    return this.instance.put('/intelligent_reception/api/v1/checkiners/add_to_checkin', joinParams(params))
  },

  /**
   * 办理入住 并验证入住单
   * @param {+} checkin_id 入住单id 
   * @param {+} info_id 主入住人id
   * @param {+} other_checkiner_ids 其他入住人 id 数组，使用逗号隔开
   * @param {+} operator 操作人
   */
  checkin(params) {
    return this.instance.post('/intelligent_reception/api/v1/checkin/order_checkin_and_check', joinParams(params))
  },

  /**
   * 线上支付
   * @param {+} amount 支付金额, 单位: 分 
   * @param {+} scan_code 支付码  
   * @param {+} pay_channel_code 支付方式，可选值：isv_qr_alipay、isv_qr_wx、isv_scan_alipay、isv_scan_wx，分别表示：支付宝主扫、微信主扫、支付宝被扫、微信被扫
   * @param {+} xbed_order_no xbed 订单号
   * @param {*} subject  支付标题，默认为支付单号
   * @param {*} body 支付描述，默认为支付单号
   */
  payOnline(params) {
    return this.instance.post('/xms/api/pay/charges', joinParams(params))
  },

  /**
   * 取消订单
   * @param {+} orderNo 
   * @param {+} type 
   */
  cancelOrder(params) {
    return this.instance.put('/api/order/cancel', joinParams(params))
  },

  /**
   * 入住单详情
   * @param {+} checkinId 
   */
  getCheckinInfo(params) {
    return this.instance.get('/api/order/oms/checkinV3', {
      params: params
    })
  },

  /**
   * 查询订单来源列表
   */
  getOrderSources() {
    return this.instance.get('/api/orderSource')
  },

  /**
   * 订单优惠类型列表
   * @param {+} type 可选值: 1:代下单优惠类型(默认); 2:前台下单类型;, 优惠类型分类
   */
  getDiscountTypeList(params) {
    return this.instance.get('/api/discountType', {
      params: params
    })
  },

  /**
   * 取消入住单
   * @param {+} cancelRule system：系统规则，artificialSelection：人工选择取消, 账务取消规则
   * @param {+} checkinId 
   * @param {+} type 
   * @param {+} remark 备注
   * @param {+} operator 操作人
   * @param {+} listConsumptionId 1,2,3(人工取消，用逗号分隔，账务主键id), 账务的主键
   */
  cancelCheckin(params) {
    return this.instance.put('/api/checkin/cancel', joinParams(params))
  },

  /**
   * 停用单列表查询
   * @param chainId 门店ID
   * @param city 城市名
   * @param endDate 创建结束时间
   * @param hotspotId 热点ID
   * @param hotspotPowerIds 热点权限范围
   * @param page 当前页
   * @param roomIdOrNo 房间ID或者房间号
   * @param size 每页大小
   * @param startDate 创建开始时间
   * @param stat 停用单状态  0-新建 1-开始 2-结束 3-停用取消(已开始) 4-未开始取消
   * @param stopEndDate 停用预结束时间
   * @param stopNo 停用单号
   * @param stopStartDate 停用预开始时间
   * @param type 停用单类型 1-待解约停用 2-设施维修停用 3-长租房停用 4-参观停用 5-预订停用 6-其它原因
   */
  getStopList(params) {
    return this.instance.get('/api/stop/list', {
      params: params
    })
  },

  /**
   * 取消停用单 (结束锁房)
   * @param {+} stopId 
   */
  removeStopItem(params) {
    return this.instance.put('/api/stop', joinParams(params))
  },

  /**
   * 删除入住人
   * @param {+} id 入住人id 
   * @param {+} operator 操作人姓名
   */
  delCheckiner(params) {
    return this.instance.delete('/api/checkiner/deleteCheckiner', {
      params: params
    })
  },

  /**
   * 获取订单详情
   * @param {+} orderNo 订单号
   */
  getOrderDetail(params) {
    return this.instance.get('/api/order/orderDetail', {
      params: params
    })
  },

  /**
   * 获取订单支付详情
   * @param {+} orderNo 订单号 
   */
  getPayInfo(params) {
    return this.instance.get('/api/pay/oms/getPayInfo', {
      params: params
    })
  },

  /**
   * 获取用户信息
   * @param {+} phone 
   * @param {+} userId 
   */
  getUserInfo(params) {
    return this.instance.get('/api/userInfo', {
      params: params
    })
  },

  /**
   * 获取用户信息
   * @param {+} phone 
   * @param {+} userId 
   */
  getUserInfoByPhone(params) {
    return this.instance.get('/api/userInfo/getUserinfsByPhone', {
      params: params
    })
  },

  /**
   * 获取退房押金
   * @param {+} checkinId 
   */
  getCheckoutMoney(params) {
    return this.instance.get('/api/checkin/checkout/getCheckOutMoney', {
      params: params
    })
  },

  /**
   * 线下支付
   * @param {+} orderNo 
   * @param {*} phone 
   * @param {+} userId 
   * @param {+} price 
   * @param {+} type 
   * @param {+} remark 
   * @param {+} operator 
   */
  payOffline(params) {
    return this.instance.put('/api/pay/otherPaySuccess', joinParams(params))
  },

  /**
   * 获取有效账务列表
   * @param {+} checkinId 
   * @param {+} page 
   * @param {+} size 
   */
  getUnfinishConsumptions(params) {
    return this.instance.get('/api/consumption/getUnfinishConsumptions', {
      params: params
    })
  },

  /**
   * 获取操作列表
   * @param {+} orderNo
   */
  getOrderTrails(params) {
    return this.instance.get('/api/orderTrail/orderNo', {
      params: params
    })
  },

  /**
   * 退房
   * @param {+} checkinId 
   * @param {+} cancelRule 
   * @param {+} listConsumptionId 
   * @param {+} realRefundAmount 
   * @param {+} bargainMoney 
   * @param {+} operator 
   * @param {+} source 
   * @param {+} remark 
   */
  checkoutOrder(params) {
    return this.instance.put('/api/checkin/checkout/checkMoney', joinParams(params))
  },

  /**
   * 退房 （包含退款逻辑）
   * @param {+} cancel_rule 取消规则 system按系统规则取消 artificialSelection人工选择取消
   * @param {+} checkin_id 入住单ID
   * @param {+} order_no xbed订单号
   * @param {+} remark 备注
   * @param {+} operator 操作人
   * @param {+} real_refund_amount 应退房费
   * @param {+} bargain_money  应退押金
   * @param {+} source  来源xms 或其他
   */
  checkoutOrderXms(params) {
    return this.instance.post('/api/v1/orders/checkout', joinParams(params))
  },

  /**
   * 续住
   * @param {+} activityId 
   * @param {+} checkinId 
   * @param {+} rentType 
   * @param {+} endDate 
   * @param {+} userId 
   * @param {+} price 
   * @param {+} source 
   * @param {+} operator 
   * @param {+} remark 
   * @param {+} invoicePrice 
   * @param {+} realPrice 
   * @param {+} orderPrice 
   * @param {+} discount 
   */
  checkinOverStay(params) {
    return this.instance.post('/api/checkin/overstay', joinParams(params))
  },

  /**
   * 取消子入住单
   * @param {+} infoId 
   * @param {+} type 
   * @param {+} remark  $jsonData['remark'] . "|" . session('user')['username'],
   * @param {+} operator 
   */
  cancelChildCheckin(params) {
    return this.instance.put('/api/checkin/cancelInfo', joinParams(params))
  },

  /**
   * 换房查询结算房费接口
   * @param {+} beginDate 
   * @param {+} endDate 
   * @param {+} roomId 
   * @param {+} checkinId 
   */
  getChangeRoomSurplus(params) {
    return this.instance.get('/api/consumption/consumptionList/surplus', {
      params: params
    })
  },

  /**
   * 查询今日可入住订单接口
   * @param {+} beginDate 
   * @param {+} endDate 
   * @param {+} roomId 
   * @param {+} checkinId 
   */
  getOrderListToCheckin(params) {
    return this.instance.get('/api/checkin/list', {
      params: params
    })
  },

  /**
   * 换房 (orderApi)
   * @param {+} checkinId 
   * @param {+} roomId 
   * @param {+} remark 
   * @param {*} totalRoomPrice 
   * @param {+} operator 
   * @param {+} needPayBalance 
   */
  changeRoom(params) {
    return this.instance.put('/api/checkin/change', joinParams(params))
  },

  /**
   * 创建订单 （聚合接口）
   * @param {+} source 订单来源
   * @param {+} begin_date 订单开始时间 YYYY-MM-DD
   * @param {+} end_date 订单结束时间
   * @param {+} real_price 订单应付价格
   * @param {+} room_ids 房间id，多个房间使用逗号隔开
   * @param {+} activity_id 活动（优惠）id
   * @param {+} reservation_name 预定人姓名
   * @param {+} reservation_phone 预定人手机号
   * @param {+} checkiners 入住人数组
   * @param {+} name 入住人姓名
   * @param {+} phone 入住人手机号
   * @param {+} source 入住人 用户来源
   * @param {+} id_no 入住人 身份证号码
   * @param {+} id_valid_period 入住人 身份证有效期
   * @param {+} id_photo 入住人 身份证头像，格式为base64
   * @param {+} discount 优惠金额
   * @param {+} discount_id 优惠类型
   * @param {+} order_price 订单原价
   * @param {+} rent_type 1 短租 2长租 3长租
   * @param {+} need_invoice 是否开发票
   * @param {+} invoice_price 发票金额
   * @param {+} operator 操作人
   * @param {+} other_no 渠道单号
   * @param {+} base_price_room_ids 信息房id，选填，使用逗号分隔
   * @param {+} room_type_id 房型id
   */
  createNewOrder(params) {
    return this.instance.post('/intelligent_reception/api/v1/orders', {
      ...params
    })
  },
  /**
   * 延迟退房列表查看接口
   * @param {+} page
   * @param {+} size
   * @param {+} source 来源
   * @param {+} orderNo 订单号
   * @param {+} roomNo 房间号
   * @param {+} name 姓名
   * @param {+} createMinTime 创建开始时间
   * @param {+} createMaxTime 创建结束时间
   * @param {+} checkinMinTime 退房开始时间
   * @param {+} checkinMaxTime 退房结束时间
   */
  getListPage(params) {
    return this.instance.post("/api/delayCheckout/listPage", { ...params })
  },
  /**
   * 提前退房接口
   * @param {+} checkinId
   */
  setEarly(params) {
    return this.instance.get("/api/delayCheckout/early", {
      params: params
    })
  },

  /**
   * 换房 (聚合接口，与退款相关)
   * @param {+} room_id 新的xbed房间ID
   * @param {+} balance 差额处理,补差价: pay, 不补差价: not_pay, 退款: refund, 不退款: not_refund
   * @param {+} checkin_id 入住单ID
   * @param {+} remark 备注
   * @param {+} operator 操作人
   */
  changeRoomXms(params) {
    return this.instance.post('/api/v1/orders/change_room', joinParams(params))
  },

  /**
   * 获取开门密码
   * @param {+} checkinInfoId 
   */
  getOpenPwd(params) {
    return this.instance.get('/api/checkinInfo/findOne', {
      params: params
    })
  },

  /**
   * 订单通知 - 获取百度语音 Token
   */
  getBaiDuToken() {
    return this.instance.get('/api/v1/tools/query_token')
  },

  /**
   * 获取线上支付结果 (ping++ 支付结果及oms支付结果)
   * @param {string} charge_no 
   */
  getPayResult(params) {
    return this.instance.get('/xms/api/pay/charges/show', {
      params: params
    })
  },

  /**
   * 线上支付重试
   */
  retryOnlinePay(params) {
    return this.instance.post('/xms/api/pay/charges/retry', joinParams(params))
  },

  /**
   * 重置入住单密码
   */
  resetPwd(params) {
    return this.instance.post('/api/checkin/resetPwd', joinParams(params))
  },

  /**
   * 计算订单价格信息- 计算价格
   * @param {Number} sourceId 订单来源id
   * @param {Number} orderPrice xbed房间原价
   * @param {Number} salePrice 渠道售价
   * @param {Number} channelDiscount 渠道优惠 
   * @param {Number} discount 总优惠， 优惠金额
   * @param {Number} realPrice 客人应付
   * @param {Number} userPay 客人实付 
   * @param {Number} channelCommission OTA佣金/渠道佣金
   * @param {Number} otherChannelExpenses 渠道活动费
   * @param {Number} receviedPrice xbed实收
   * @param {Number} invoicePrice 发票金额 
   */
  calculatePrice(params) {
    return this.instance.post('/api/source/priceCalculate', joinParams(params))
  },

  /**
   * xms订单接口-查询订单支付金额详情
   * @param {*} orderNo 订单号
   * @param {*} pageNum 
   * @param {*} pageSize 
   */
  getOrderPayDetail(params) {
    return this.instance.post('/api/order/xms/findOrderPayDetial', joinParams(params))
  },

  /**
   * xms订单接口-订单详情修改预订金额
   * @param {*} orderNo 
   * @param {*} payNo 
   * @param {*} userName 
   * @param {*} reason 
   * @param {*} discount 
   * @param {*} realPrice 
   * @param {*} channelCommission 
   * @param {*} receivedPrice 
   * @param {*} invoicePrice 
   */
  modifyBookingAmount(params) {
    return this.instance.post('/api/order/xms/modifyBookingAmount', joinParams(params))
  }
}


// WEBPACK FOOTER //
// ./src/api/order.js